import React from 'react';

export const ModalCalendy = ({text}) => {
	return (
		<div className="modal fade px-0 show" id="commencerReferent" aria-labelledby="commencerReferentLabel" aria-modal="true" role="dialog" >
			<div className="modal-dialog container-fluid px-2">
				<div className="modal-content rounded">
					<div className="modal-body">
						<h2 className="h1 text-primary font-weight-bolder ls-n1 lh-copy mb-0 mt-4 mt-lg-auto lh-title" id="commencerReferentLabel">Prise de RDV avec conseiller Sérénita</h2>
						<p className="lh-base font-weight-normal mt-3 mb-5">
                            Veuillez réserver un rendez-vous avec un conseiller Sérénita avec le lien suivant:<br/>
                            <a className="text-info" href='https://calendly.com/service-serenita/serenita' target='_blank'>https://calendly.com/service-serenita/serenita</a>
                        </p>
						<p className="lh-base font-weight-normal mt-3 mb-5">
                            Il faut prendre le rdv sur Calendly <strong>obligatoirement</strong>. <br />
							Le rdv pourra être modifié par la famille ou le conseiller Sérénita, mais il doit être pris sur Calendly pour que nous puissions le suivre et le relancer si besoin.
                        </p>
						<div className="block mt-4 mt-lg-auto text-right">
							<button type="button" className="btn btn-light" data-dismiss="modal">Fermer</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}